/**
 * OLGVML Theme - Global JavaScript
 */

// Cart functionality
class CartDrawer {
  constructor() {
    this.cart = null;
    this.init();
  }

  init() {
    this.fetchCart();
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('cart:refresh', () => this.fetchCart());
  }

  async fetchCart() {
    try {
      const response = await fetch('/cart.js');
      this.cart = await response.json();
      this.updateCartCount();
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  updateCartCount() {
    const cartCountElements = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
    const cartCount = this.cart?.item_count || 0;

    cartCountElements.forEach(element => {
      element.textContent = cartCount;
      element.closest('.cart-count-bubble')?.classList.toggle('hidden', cartCount === 0);
    });
  }

  async addItem(id, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: id,
          quantity: quantity
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add item to cart');
      }

      await this.fetchCart();
      return await response.json();
    } catch (error) {
      console.error('Error adding to cart:', error);
      throw error;
    }
  }
}

// Initialize cart
const cart = new CartDrawer();

// Video autoplay handling
document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('video[autoplay]');

  videos.forEach(video => {
    // Ensure video plays on mobile
    video.play().catch(error => {
      console.log('Video autoplay was prevented:', error);
    });
  });

  // Intersection Observer for lazy loading videos
  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          if (video.paused) {
            video.play().catch(err => console.log('Play failed:', err));
          }
        } else {
          const video = entry.target;
          if (!video.paused) {
            video.pause();
          }
        }
      });
    }, { threshold: 0.5 });

    videos.forEach(video => videoObserver.observe(video));
  }
});

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const href = this.getAttribute('href');
    if (href !== '#') {
      e.preventDefault();
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  });
});

// Add to cart forms
document.addEventListener('submit', async (e) => {
  if (e.target.matches('form[action="/cart/add"]')) {
    e.preventDefault();

    const form = e.target;
    const submitButton = form.querySelector('[type="submit"]');
    const formData = new FormData(form);

    // Disable button during submission
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();

      // Refresh cart
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // Show success message (you can customize this)
      if (submitButton) {
        submitButton.textContent = 'Added!';
        setTimeout(() => {
          submitButton.textContent = 'Add to Cart';
          submitButton.disabled = false;
        }, 2000);
      }
    } catch (error) {
      console.error('Error:', error);
      if (submitButton) {
        submitButton.textContent = 'Error - Try Again';
        setTimeout(() => {
          submitButton.textContent = 'Add to Cart';
          submitButton.disabled = false;
        }, 2000);
      }
    }
  }
});

// Expose cart to global scope
window.cartDrawer = cart;
